import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddNewsAndEventsSlice = createSlice({
    name: "addNewsAndEvents",
    initialState,
    reducers: {
        addNewsAndEventsRequest(state) {
            state.loading = true;
        },
        addNewsAndEventsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addNewsAndEventsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addNewsAndEventsStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addNewsAndEventsRequest,
    addNewsAndEventsRequestSuccess,
    addNewsAndEventsRequestError,
    addNewsAndEventsStateReset
} = AddNewsAndEventsSlice.actions;

export default AddNewsAndEventsSlice.reducer;
